import React from 'react';
import * as FiIcons from 'react-icons/fi';
import { GiBrain } from 'react-icons/gi';

const SafeIcon = ({ icon, name, ...props }) => {
  let IconComponent;
  
  try {
    IconComponent = icon || (name && FiIcons[`Fi${name}`]);
  } catch (e) {
    IconComponent = null;
  }
  
  // Use brain icon from game-icons as fallback
  return IconComponent ? React.createElement(IconComponent, props) : <GiBrain {...props} />;
};

export default SafeIcon;